import { render } from "./Onboard.vue?vue&type=template&id=2f8ade87"
import script from "./Onboard.vue?vue&type=script&lang=ts"
export * from "./Onboard.vue?vue&type=script&lang=ts"
script.render = render

export default script